import { createReducer, on } from '@ngrx/store';
import { NavigationState } from 'src/app/models/navigation/navigation-state';
import * as navigationActions from './navigation.actions';

export const navigationKey = 'navigation';

export const initialState: NavigationState = {
    url: '',
    navigate: false,
    canAccessToLastUrl: true,
    showSuppotButton: false
};

export const navigationReducer = createReducer(
    initialState,
    on(navigationActions.navigate, (state, response) => ({
        ...state,
        url: response.url,
        navigate: true
    })),
    on(navigationActions.endNavigate, (state) => ({
        ...state,
        navigate: false
    })),
    on(navigationActions.lastUrlAccesible, (state) => ({
        ...state,
        canAccessToLastUrl: true
    })),
    on(navigationActions.lastUrlUnAccesible, (state) => ({
        ...state,
        canAccessToLastUrl: false
    })),
    on(navigationActions.setSupportButton, (state, response) => ({
        ...state,
        showSuppotButton: response.value
    }))
);
